import {NgModule} from '@angular/core';
import {ManagementComponent} from './management/management.component';
import {GameManagementService} from './game-management.service';
import {RouterModule, Routes} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';

const routes: Routes = [
  {path: 'admin', component: ManagementComponent}
];

@NgModule({
    imports: [
        BrowserModule,
        RouterModule.forChild(routes),
        FormsModule
    ],
  declarations: [
    ManagementComponent
  ],
  providers: [
    GameManagementService
  ]
})
export class AdminModule {

}
